module.exports = __webpack_public_path__ + "public/img/prakerja-new.81d911bf.png";